import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getEducationStates } from "./Axios";

const EducationStateSelect = props => {
  const [education_states, setEducationStates] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "education_state");
  };

  useEffect(() => {
    getEducationStates((response) => {
      if (response && response.data) {
        const newEducationStates = response.data.map((education_state) => ({
          value: education_state.id,
          label: education_state.name,
          uniqueIdentifier: education_state.unique_identifier,
        }));
        setEducationStates(newEducationStates);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-education-state-search"
      onChange={handleChange}
      options={education_states}
      placeholder="Buscar y seleccionar un estado académico"
      value={
        education_states.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default EducationStateSelect;

